// Diagnostic disconnect code shown on the disconnect/error screens. The operator
// reads the number to their Account Manager, who maps it to the cause via
// backend/app/core/disconnect_codes.py. Numbers come from lib/disconnectCodes.ts.
export default function DisconnectCode({ code }: { code: number }) {
  return (
    <p className="text-[12px] leading-relaxed text-white/45">
      Error code <span className="font-bold tracking-wide text-white/80">{code}</span>
      {' — '}give this number to your Account Manager
    </p>
  )
}
